var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.914 13.08C3.689 12.714 3 11.564 3 10a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 1.565-.689 2.714-.914 3.08C18.204 16.139 14.802 18.898 12 21c-2.802-2.102-6.204-4.861-8.086-7.92"
  })));
};
export default SvgHeartFilled;